import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { OvertimeHoursSummary } from '../../models/overtime-hours-summary.model';
import { endOfDay, endOfMonth, startOfMonth, subMonths } from 'date-fns';
import { OvertimeManagementService } from '../../services/overtime-management.service';
import { FilterService } from '../../../../_shared/services';
import { SummaryRequest, WidgetFilterData } from '../../../../_shared/models';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { OvertimeDriverStateService } from '../../services/overtime-driver-state.service';
import { Subject, takeUntil } from 'rxjs';
import { MetricBlockComponent } from '../metric-block/metric-block.component';
import { DateInterval } from '../../../../_shared/enums';
import { ErrorHandlerService } from '../../../../_shared/services/error-handler.service';
import { formatValue } from '../../../../_shared/helpers/kpiWidget/kpi-formatters.helper';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-overtime-hours-summary',
  standalone: true,
  imports: [NgbTooltipModule, MetricBlockComponent, TranslocoDirective],
  templateUrl: './overtime-hours-summary.component.html',
  styleUrl: './overtime-hours-summary.component.scss'
})
export class OvertimeHoursSummaryComponent implements OnInit, OnDestroy {
  overtimeHoursSummary: OvertimeHoursSummary = {} as OvertimeHoursSummary;
  isLoading: boolean = true;
  accountId: number;
  currentDate: Date = new Date();
  summaryRequest: SummaryRequest = {
    accountIds: [],
    timeFrom: startOfMonth(this.currentDate),
    timeTo: endOfDay(this.currentDate),
    interval: DateInterval.Month,
    previousTimeFrom: startOfMonth(subMonths(this.currentDate, 1)),
    previousTimeTo: endOfMonth(subMonths(this.currentDate, 1)),
  };

  destroy$: Subject<void> = new Subject<void>();
  cancel$: Subject<void> = new Subject<void>();
  dateInterval: DateInterval = DateInterval.Month;

  private overtimeManagementService = inject(OvertimeManagementService);
  private filterService = inject(FilterService);
  private overtimeDriverState = inject(OvertimeDriverStateService);
  private errorHandlerService = inject(ErrorHandlerService);

  ngOnInit(): void {
    this.overtimeDriverState.refreshDriverOvertime$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.getOvertimeHoursSummary();
    });

    this.filterService.filterUpdated$.pipe(takeUntil(this.destroy$)).subscribe((filter: WidgetFilterData) => {
      if (!filter || Object.values(filter).every(x => x == null)) {
        return;
      }

      this.summaryRequest.accountIds = [...this.filterService.filter.accountIds]
      this.getOvertimeHoursSummary();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  async getOvertimeHoursSummary() {
    this.isLoading = true;
    try {
      this.cancel$.next();
      var result = await this.overtimeManagementService.getDriverOvertimeHoursSummary(this.summaryRequest, this.cancel$);
      if (result.data) {
        this.overtimeHoursSummary = result.data;
      }

      this.isLoading = false;
    } catch (error: any) {
      this.errorHandlerService.handleError(error, {
        callback: () => {
          this.isLoading = false;
        }
      });
    }
  }

  formatCost(value: number): string {
    return formatValue(value);
  }

  getClass(value: number): string {
    if (value > 0) return 'text-success';
    if (value < 0) return 'text-attention';
    return 'text-secondary';
  }
}